import { Navigate, Route, Routes } from 'react-router-dom';
import DashboardLayout from '../components/layout/DashboardLayout';
import ProtectedRoute from './ProtectedRoute';
import Login from '../pages/Login';
import LoadingScreen from '../components/common/LoadingScreen';
import Dashboard from '../pages/Dashboard';
import Partners from '../pages/Partners';
import ApiKeys from '../pages/ApiKeys';
import Devices from '../pages/Devices';
import UsageLogs from '../pages/UsageLogs';
import Analytics from '../pages/Analytics';
import Settings from '../pages/Settings';
import Profile from '../pages/Profile';
import { useAuth } from '../context/AuthContext';

function LoginRoute() {
  const { isAuthenticated, loading } = useAuth();
  if (loading) return <LoadingScreen />;
  if (isAuthenticated) return <Navigate to="/" replace />;
  return <Login />;
}

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginRoute />} />
      <Route
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route
          path="partners"
          element={
            <ProtectedRoute adminOnly>
              <Partners />
            </ProtectedRoute>
          }
        />
        <Route path="api-keys" element={<ApiKeys />} />
        <Route path="devices" element={<Devices />} />
        <Route path="usage-logs" element={<UsageLogs />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="settings" element={<Settings />} />
        <Route path="profile" element={<Profile />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
